import classNames from "classnames";

import styles from "./Container.module.scss";

export const Container = ({ className, children }) => (
  <div className={classNames(styles.container, className)}>{children}</div>
);
